import { createContext, useContext } from 'react';

export const DialogContentContainerContext = createContext<HTMLElement | null>(
  null,
);

/**
 * The content node of the surrounding dialog, or `null` outside one.
 *
 * A modal dialog blocks pointer events everywhere but its own content and traps
 * focus there. A popup portalled to the body therefore renders, but cannot be
 * clicked or reached with the keyboard, so popups inside a dialog must portal
 * into this node instead.
 */
export function useDialogContentContainer() {
  return useContext(DialogContentContainerContext);
}
